// frontend-react/src/components/common/SparkGlyph.js
// Section 12 — minimal projection-trend sparkline. Ported from the mockup-sandbox-1
// Pass6Charts.SparkGlyph (commit d08a417d), adapted to DD: DD accent default + a
// graceful 0/1-data-point render. The original divided by (length - 1) → NaN at
// length === 1; the Section 11 prediction-history substrate begins with exactly one
// calculation_date, so the single-point case is the FIRST thing this renders.
import React from 'react';

const SparkGlyph = ({ values, w = 64, h = 22, color = '#f59e0b', strokeWidth = 1.5 }) => {
  if (!values || values.length === 0) return null;

  // Single point (or, after normalization, an all-equal series): render a centered dot
  // instead of a NaN polyline. This is the live production state today (one run-day).
  if (values.length === 1) {
    return (
      <svg width={w} height={h} viewBox={`0 0 ${w} ${h}`} className="shrink-0" aria-hidden>
        <circle cx={w / 2} cy={h / 2} r={2} fill={color} />
      </svg>
    );
  }

  const min = Math.min(...values);
  const max = Math.max(...values);
  const pts = values
    .map((v, i) => {
      const x = (i / (values.length - 1)) * w;
      const y = h - 2 - ((v - min) / (max - min || 1)) * (h - 4);
      return `${x},${y}`;
    })
    .join(' ');

  return (
    <svg width={w} height={h} viewBox={`0 0 ${w} ${h}`} className="shrink-0" aria-hidden>
      <polyline fill="none" stroke={color} strokeWidth={strokeWidth} points={pts} />
    </svg>
  );
};

export default SparkGlyph;
